import * as React from 'react';

import { IMainScreenProps } from '../../types/public';
import { Aside } from '../Aside';
import { FormHeader } from '../FormHeader';

import * as styles from './styles.css';

export function MainScreenDesktop(props: IMainScreenProps) {
  const { backToPage, main, progressBar, showGoBackBtn, handleGoBack, goBackText, withSaleRentIntro } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['aside']}>
        <Aside backToPage={backToPage} withSaleRentIntro={withSaleRentIntro} />
      </div>
      <div className={styles['main']}>
        <div className={styles['header']}>
          <FormHeader
            progressBar={progressBar}
            showGoBackBtn={showGoBackBtn}
            handleGoBack={handleGoBack}
            goBackText={goBackText}
          />
        </div>
        <div className={styles['content']}>{main}</div>
      </div>
    </div>
  );
}
